
export function showActiveYears(years){
    if(years){
        return `${years[0]} - ${years[years.length-1]}`;
    }
}
